export default {
  ITEM_DIALOG_SET_ACTIVE_VIEW: 'ITEM_DIALOG_SET_ACTIVE_VIEW',
  ITEM_DIALOG_SET_STAGES: 'ITEM_DIALOG_SET_STAGES',
  ITEM_DIALOG_ADD_STAGE: 'ITEM_DIALOG_ADD_STAGE',
  ITEM_DIALOG_DELETE_STAGE: 'ITEM_DIALOG_DELETE_STAGE',
  ITEM_DIALOG_SET_FORM_DATA: 'ITEM_DIALOG_SET_FORM_DATA',
  ITEM_DIALOG_SET_STAGE_FORM_DATA: 'ITEM_DIALOG_SET_STAGE_FORM_DATA',
  ITEM_DIALOG_SET_HAS_VARIANTS: 'ITEM_DIALOG_SET_HAS_VARIANTS',
  ITEM_DIALOG_SET_VARIANTS: 'ITEM_DIALOG_SET_VARIANTS',
  ITEM_DIALOG_SET_SUBTOTAL: 'ITEM_DIALOG_SET_SUBTOTAL',
  ITEM_DIALOG_SET_VARIANTS_TOTAL: 'ITEM_DIALOG_SET_VARIANTS_TOTAL',
  ITEM_DIALOG_SET_CHARGES_TOTAL: 'ITEM_DIALOG_SET_CHARGES_TOTAL',
  ITEM_DIALOG_SET_DECORATIONS_TOTAL: 'ITEM_DIALOG_SET_DECORATIONS_TOTAL',
  ITEM_DIALOG_SET_CHARGES: 'ITEM_DIALOG_SET_CHARGES',
  ITEM_DIALOG_SET_DECORATION: 'ITEM_DIALOG_SET_DECORATION',
  ITEM_DIALOG_SET_IMAGES: 'ITEM_DIALOG_SET_IMAGES',
  ITEM_DIALOG_SET_VARIANT_SCHEMA: 'ITEM_DIALOG_SET_VARIANT_SCHEMA',
  ITEM_DIALOG_RESET: 'ITEM_DIALOG_RESET',
};

